<template lang="pug">
  transition(name="fade")
    .popup-modal(v-if="loginModalActive")
      .popup-modal-beneath(@click="closeModal")
      .popup-modal-content
        .popup-modal-title 您目前尚未登入喔！
        .popup-modal-subtitle 立即登入即可將喜愛的商品加入收藏列表，讓您不會錯過任何激省商品喔！
        .popup-modal-actions
          .cancel(@click="cancelClicked") 等等好了
          .foward(@click="fowardClicked") 前往登入

</template>

<script>
export default {
  name: 'login-modal',
  props:{
    loginModalActive:{
      type: Boolean,
      required: true,
      default: false
    }
  },
  data(){
    return{
    }
  },
  methods:{
    fowardClicked(){
      this.$emit('foward')
    },
    cancelClicked(){
      this.$emit('cancel')
    },
    closeModal(){
      this.$emit('closeModal')
    }
  },
}
</script>

<style lang="scss">
  
</style>
